import styled from "styled-components";
import variables from '../../../data/variables';

export const SectionIntro = styled.div`
  padding: 8rem 0 4rem 0;
  @media(max-width: ${variables.breakpointPhone}) {
    padding: 4rem 0 4rem 0;
  }
`
